export default function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6" data-testid={testid}>
      <div>
        <h1 className="font-display text-2xl md:text-3xl font-semibold text-slate-900 leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-slate-500 mt-1 max-w-2xl">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
